var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00011 0C4.02954 0 0 4.02933 0 8.99989C0 13.9708 4.02954 18 9.00011 18C13.9708 18 18.0001 13.9708 18.0001 8.99989C18.0001 4.02933 13.9708 0 9.00011 0Z",
    fill: "#1ED760"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3239 7.97869C11.4228 6.25581 6.6375 6.0974 3.86806 6.93793C3.42335 7.07281 2.95305 6.82176 2.81828 6.37704C2.68351 5.93211 2.93435 5.46213 3.37939 5.32693C6.55851 4.36194 11.8433 4.5483 15.1831 6.53083C15.5832 6.76834 15.7145 7.28496 15.4773 7.68432C15.24 8.08433 14.7229 8.2162 14.3239 7.97869ZM14.2289 10.5305C14.0254 10.8608 13.5936 10.9643 13.2638 10.7616C10.8451 9.2748 7.15702 8.84416 4.29559 9.71274C3.92449 9.82484 3.53254 9.61559 3.41991 9.24524C3.30803 8.87414 3.51738 8.48294 3.88773 8.3701C7.15659 7.37824 11.2201 7.85864 13.998 9.56583C14.3279 9.76895 14.4317 10.201 14.2289 10.5305ZM13.1276 12.9812C12.966 13.2463 12.6206 13.3295 12.3564 13.1678C10.2429 11.8761 7.58271 11.5844 4.44992 12.3C4.14803 12.3692 3.84721 12.18 3.77833 11.8782C3.70911 11.5763 3.89762 11.2755 4.20015 11.2066C7.6285 10.4228 10.5694 10.7602 12.9416 12.2097C13.2061 12.3713 13.2894 12.7168 13.1276 12.9812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.fca514a6edf4c4e30b28f29bbe3e7369.svg";
export { ForwardRef as ReactComponent };